import SelectConfiscation from './SelectConfiscation';

export default SelectConfiscation;
